<div class="relative h-full w-full">
  <div [class]="class() + ' relative h-full w-full'">
    <div class="flex h-full w-full items-center">
      <i
        [class]="ICONS.magnifyingGlass"
        class="text-text-tertiary mr-1 shrink-0"
        style="font-size: 12px; line-height: 1"></i>

      <div class="relative flex-1">
        <div
          #textZone
          class="text-zone absolute inset-0 overflow-hidden py-0.5 text-[12px] leading-normal whitespace-pre"
          [innerHTML]="highlightedQuery()"></div>
        <input
          #searchInput
          type="text"
          [placeholder]="placeholder()"
          [(ngModel)]="queryValue"
          (input)="onInputChange($event)"
          (keydown)="onKeyDown($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
          (scroll)="onScrollSync($event)"
          class="caret-text-primary placeholder:text-text-tertiary relative z-10 w-full overflow-x-auto border-none bg-transparent py-1 text-[12px] text-transparent outline-none"
          style="white-space: nowrap" />
      </div>
    </div>

    @if (query()) {
      <button (click)="clearQuery()" class="hover:bg-interactive ml-1 rounded p-1">
        <svg
          class="h-4 w-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    } @else {
      <span
        class="bg-page text-text-tertiary pointer-events-none ml-1 rounded px-1.5 py-0.5 font-mono text-xs">
        /
      </span>
    }
  </div>

  @if (showSuggestions() && suggestions().length > 0) {
    <div
      role="menu"
      aria-orientation="vertical"
      [attr.aria-labelledby]="'dropdown-button'"
      class="bg-elevated border-weak absolute top-full z-50 mt-1 flex w-full min-w-max flex-col rounded-lg border p-1 shadow-lg">
      @for (suggestion of suggestions(); track $index) {
        <div
          role="menuitem"
          [class]="
            'text-text-primary hover:bg-interactive flex w-full cursor-pointer flex-col justify-between rounded-lg px-2 py-1 text-left text-sm disabled:cursor-not-allowed disabled:opacity-50' +
            (selectedSuggestion() === $index ? ' bg-interactive' : '')
          "
          (mousedown)="applySuggestion(suggestion)">
          <div class="text-sm font-medium">{{ suggestion.text }}</div>
          <div class="text-text-secondary text-xs">{{ suggestion.description }}</div>
        </div>
      }
    </div>
  }
</div>
